import { addStepsIndicator } from "../../../../assets/js/src/general/elements/tables";
import { localDateTimeString } from "../../../../assets/js/src/general/utils";

// These are excluded from the DataTables column selector.
// They are either always on or contextually activated/deactivated.
export const notSelectable = [
  "actions",
  "bouncedAt",
  "checkbox",
  "name",
  "opportunityDescription",
  "opportunityKind",
  "opportunityTime",
  "origin",
  "status",
  "task",
  "url",
];

const defaultCols = [
  "actions",
  "campaign",
  "checkbox",
  "click",
  "name",
  "opens",
  "phones",
  "steps",
  "time",
  "timezone",
];

const linkedinCols = [
  "actions",
  "campaign",
  "checkbox",
  "click",
  "name",
  "time",
  "timezone",
  "url",
];

export const defaultVisibilityByKind = {
  phoneCall: defaultCols,
  sendEmailAfterInmail: defaultCols,
  sendInmail: linkedinCols,
  linkedinConnectionRequest: linkedinCols,
  generalTask: defaultCols,
  bounce: ["bouncedAt"]
    .concat(defaultCols)
    .filter((x) => !["steps", "time"].includes(x)),
  manualToDo: ["checkbox", "name", "task", "time", "actions"],
  opportunity: [
    "checkbox",
    "name",
    "opportunityKind",
    "opportunityTime",
    "opportunityDescription",
    "actions",
  ],
  aiToDo: ["checkbox", "name", "origin", "task", "time", "actions"],
};

export const columns = [
  {
    data: (x) => x,
    orderable: false,
    name: "checkbox",
  },
  {
    data: (x) => x,
    orderable: true,
    name: "time",
    title: "Due Date",
    render: (toDo, type) =>
      type === "sort" ? toDo?.visibleFrom || toDo?.dueDate : toDo,
  },
  {
    data: (x) => x,
    orderable: true,
    name: "opportunityTime",
    title: "Due Date",
    visible: false,
    render: (toDo, type) => {
      const { opportunityTime, snoozedTime } = toDo;
      if (!opportunityTime) return "";
      if (type === "sort") return opportunityTime;
      return snoozedTime
        ? `<span class="opportunity-snooze-span">${opportunityTime}<i class="far fa-zzz" data-toggle="tooltip" title="Snoozed on ${snoozedTime}"></i></span>`
        : opportunityTime;
    },
  },
  {
    data: (x) => x,
    orderable: true,
    name: "url",
    title: "URL",
    className: "text-center",
    render: (toDo) => toDo?.data?.url || "",
  },
  {
    data: (x) => x,
    orderable: true,
    name: "status",
    title: "Status",
  },
  {
    data: (x) => x,
    name: "name",
    orderable: true,
    title: "Name",
    render: (toDo, type) => (type === "sort" ? toDo?.candidateName : toDo),
  },
  {
    data: (x) => x,
    title: "Origin",
    name: "origin",
    orderable: false,
    visible: false,
  },
  {
    data: (x) => x,
    name: "task",
    title: "Task",
    orderable: false,
    visible: false,
  },
  {
    data: (x) => x,
    orderable: true,
    name: "phones",
    title: "Phones",
    render: (toDo, type) =>
      type === "sort"
        ? (toDo?.candidatePhones || []).length
        : (toDo?.candidatePhones || []).join(","),
  },
  {
    data: "candidateTimezone",
    name: "timezone",
    title: "Local Time",
    orderable: true,
    render: (tz) =>
      tz ? localDateTimeString(Date.now() / 1000, null, tz) : "",
  },
  {
    data: "candidateRole",
    orderable: true,
    name: "role",
    visible: false,
    title: "Job Title",
  },
  {
    data: "candidateCompany",
    name: "company",
    title: "Company",
    visible: false,
    orderable: true,
  },
  {
    data: (x) => x,
    orderable: true,
    name: "campaign",
    title: "Campaign",
    render: (toDo, type) => (type === "sort" ? toDo?.campaignName : toDo),
  },
  {
    data: "opportunityKind",
    orderable: true,
    name: "opportunityKind",
    title: "Opportunity",
    visible: false,
  },
  {
    data: (x) => x.opportunityDescription?.concise || { concise: "" },
    orderable: false,
    name: "opportunityDescription",
    title: "Description",
    visible: false,
  },
  {
    data: "visibleFrom", // backend populates this as time of bounce
    orderable: true,
    name: "bouncedAt",
    title: "Due Date",
    visible: false,
    render: (visibleFrom) => visibleFrom || 0,
  },
  {
    data: "events",
    name: "steps",
    title: "Steps",
    orderable: true,
    render: (events, type) => addStepsIndicator(events, type), // use sort logic from addStepsIndicator
  },
  {
    data: (x) => x,
    name: "opens",
    title: "Opens",
    orderable: true,
    render: (toDo) => (toDo.candidateOpens === null ? "" : toDo.candidateOpens),
  },
  {
    data: (x) => x,
    name: "clicks",
    title: "Clicks",
    orderable: true,
    render: (toDo) =>
      toDo.candidateClicks === null ? "" : toDo.candidateClicks,
  },
  {
    data: (x) => x,
    name: "actions",
    title: "Actions",
    orderable: false,
    className: "background-color-textWhite",
  },
];
